import React, { useEffect } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Hero from './sections/Hero';
import About from './sections/About';
import Services from './sections/Services';
import AITools from './sections/AITools';
import Domains from './sections/Domains';
import Contact from './sections/Contact';
import Clients from './sections/Clients';
import Navbar from './components/Navbar';
import GlobalStyles from './styles/GlobalStyles';
import { theme } from './styles/theme';

gsap.registerPlugin(ScrollTrigger);

const MainContainer = styled.div`
  background-color: ${props => props.theme.colors.background};
  color: ${props => props.theme.colors.text};
`;

function App() {
  useEffect(() => {
    // Smooth scroll initialization
    gsap.to('body', { duration: 0, css: { visibility: 'visible' } });
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <MainContainer>
        <Navbar />
        <main>
          <Hero />
          <About />
          <Services />
          <AITools />
          <Domains />
          <Clients />
          <Contact />
        </main>
      </MainContainer>
    </ThemeProvider>
  );
}

export default App;
